"use client";
import { jsxs as r, jsx as e } from "react/jsx-runtime";
const n = ({
  title: t,
  titleId: l,
  desc: a,
  descId: i,
  ...d
}) => /* @__PURE__ */ r(
  "svg",
  {
    xmlns: "http://www.w3.org/2000/svg",
    xmlnsXlink: "http://www.w3.org/1999/xlink",
    id: "flag-icons-gd",
    viewBox: "0 0 640 480",
    "aria-labelledby": l,
    "aria-describedby": i,
    ...d,
    children: [
      a ? /* @__PURE__ */ e("desc", { id: i, children: a }) : null,
      t ? /* @__PURE__ */ e("title", { id: l, children: t }) : null,
      /* @__PURE__ */ e("defs", { children: /* @__PURE__ */ r("g", { id: "gd-c", children: [
        /* @__PURE__ */ r("g", { id: "gd-b", children: [
          /* @__PURE__ */ e(
            "path",
            {
              id: "gd-a",
              fill: "#fcd116",
              d: "M0-1v1h.5",
              transform: "rotate(18 0 -1)"
            }
          ),
          /* @__PURE__ */ e("use", { xlinkHref: "#gd-a", transform: "scale(-1 1)" })
        ] }),
        /* @__PURE__ */ e("use", { xlinkHref: "#gd-b", transform: "rotate(72)" }),
        /* @__PURE__ */ e("use", { xlinkHref: "#gd-b", transform: "rotate(144)" }),
        /* @__PURE__ */ e("use", { xlinkHref: "#gd-b", transform: "rotate(216)" }),
        /* @__PURE__ */ e("use", { xlinkHref: "#gd-b", transform: "rotate(288)" })
      ] }) }),
      /* @__PURE__ */ e("path", { fill: "#ce1126", d: "M0 0h640v480H0z" }),
      /* @__PURE__ */ e("path", { fill: "#007a5e", d: "M67.2 67.2h505.6v345.6H67.2z" }),
      /* @__PURE__ */ e("path", { fill: "#fcd116", d: "M67.2 67.3h505.6L67.2 412.9h505.6z" }),
      /* @__PURE__ */ e("circle", { cx: 319.9, cy: 240.1, r: 57.6, fill: "#ce1126" }),
      /* @__PURE__ */ e(
        "use",
        {
          xlinkHref: "#gd-c",
          width: "100%",
          height: "100%",
          transform: "translate(320 240)scale(52.8)"
        }
      ),
      /* @__PURE__ */ e(
        "use",
        {
          xlinkHref: "#gd-d",
          width: "100%",
          height: "100%",
          x: -100,
          transform: "translate(-30.3)"
        }
      ),
      /* @__PURE__ */ e(
        "use",
        {
          xlinkHref: "#gd-c",
          id: "gd-d",
          width: "100%",
          height: "100%",
          transform: "translate(320 33.6)scale(31.2)"
        }
      ),
      /* @__PURE__ */ e(
        "use",
        {
          xlinkHref: "#gd-d",
          width: "100%",
          height: "100%",
          x: 100,
          transform: "translate(30.3)"
        }
      ),
      /* @__PURE__ */ e(
        "path",
        {
          fill: "#ce1126",
          d: "M102.3 240.7a80.4 80.4 0 0 0 33.5 33.2 111 111 0 0 0-11.3-45z"
        }
      ),
      /* @__PURE__ */ e(
        "path",
        {
          fill: "#fcd116",
          d: "M90.1 194.7c10.4 21.7-27.1 73.7 35.5 85.9a63.2 63.2 0 0 1-10.9-41.9 70 70 0 0 1 32.5 30.8c16.4-59.5-42-55.8-57.1-74.8"
        }
      ),
      /* @__PURE__ */ e(
        "use",
        {
          xlinkHref: "#gd-d",
          width: "100%",
          height: "100%",
          x: -100,
          transform: "translate(-30.3 414.6)"
        }
      ),
      /* @__PURE__ */ e(
        "use",
        {
          xlinkHref: "#gd-c",
          width: "100%",
          height: "100%",
          transform: "translate(320 448.2)scale(31.2)"
        }
      ),
      /* @__PURE__ */ e(
        "use",
        {
          xlinkHref: "#gd-d",
          width: "100%",
          height: "100%",
          x: 100,
          transform: "translate(30.3 414.6)"
        }
      )
    ]
  }
);
export {
  n as default
};
